import { render } from "./MediaOverlay.vue?vue&type=template&id=374b6d8a&scoped=true"
import script from "./MediaOverlay.vue?vue&type=script&lang=js"
export * from "./MediaOverlay.vue?vue&type=script&lang=js"

import "./MediaOverlay.vue?vue&type=style&index=0&id=374b6d8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374b6d8a"]])

export default __exports__